import React, { useContext, useEffect, useState } from "react";
import { StateContext } from "../../../utils/context";
import TenantContext from "../../../utils/tenantContext";
import { stripeSubscriptionService } from "../../../jwt/_services/stripeSubscription.service";
import { canSubUserManageSubscription } from "../../../utils/subscriptionUtils";
import SubscriptionPlanBadge from "../../../components/subscriptionPlanBadge";

import { getActiveTenantSubscription } from "../../../views/stripeSubscription/planUtils";

const SubscriptionPlan = () => {
  const { currentUser } = useContext(StateContext);
  const { tenant } = useContext(TenantContext);
  const [plans, setPlans] = useState(null);

  const subscription = getActiveTenantSubscription(currentUser);
  const planName = subscription?.plan_name || null;
  const showSubUserSubscription = canSubUserManageSubscription(currentUser, tenant);

  useEffect(() => {
    if (!showSubUserSubscription || !planName) {
      return;
    }

    let isMounted = true;

    stripeSubscriptionService
      .listPublicPlansCached()
      .then((items) => {
        if (isMounted) {
          setPlans(items);
        }
      })
      .catch(() => {
        if (isMounted) {
          setPlans([]);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [showSubUserSubscription, planName]);

  if (!showSubUserSubscription || !planName || plans === null) {
    return null;
  }

  return (
    <SubscriptionPlanBadge
      planName={planName}
      plans={plans}
      linkTo="/subscription"
      topbar
    />
  );
};

export default SubscriptionPlan;
